import { useEffect, useCallback } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { useHistory } from 'react-router-dom'

import Categories from './Categories'
import SearchResults from '../search/SearchResults'
import SearchForm from '../search/SearchForm'
import VirtualBackgroundMenu from '../vb/VirtualBackgroundMenu'

import { selectTopicPhotos, selectTotalTopicPhotos, getTopic, selectTotalScrollToImgId } from './reducer'
import { getByTopicFirstCall, setTopic } from './actions'

import './Home.css'

const categories = {
  nature: 'nature',
  interiors: 'interiors',
  art: 'art',
  travel: 'travel',
}

function Home() {
  const dispatch = useDispatch()
  const activeCategory = useSelector(getTopic)
  const topicImages = useSelector(selectTopicPhotos)
  const totalTopicPageImages = useSelector(selectTotalTopicPhotos)
  const scrollToImgId = useSelector(selectTotalScrollToImgId)
  const firstResultImgId = String(topicImages[0]?.id)
  const history = useHistory()

  const setActiveCategory = category => {
    dispatch(setTopic(category))
  }

  const onSearch = useCallback(
    (searchTerm) => {
      history.push({
        pathname: '/search',
        search: `?query=${encodeURIComponent(searchTerm)}`,
        state: { searchTerm },
      })
    },
    [history]
  )

  useEffect(() => {
    if (!topicImages.length) {
      for (let category in categories) {
        dispatch(getByTopicFirstCall({ query: category, page: 1 }))
      }
    }
  }, [dispatch, topicImages.length, activeCategory])

  // Handles move page to last-viewed image, per topic
  useEffect(() => {
    // Find the img element with the specified ID
    const targetImg = document.getElementById(scrollToImgId)

    // Check if the img element is found
    if (typeof targetImg?.getBoundingClientRect === 'function') {
      // Get the top offset of the target img element
      const isTopImage = Boolean(scrollToImgId && String(scrollToImgId) === firstResultImgId)
      const targetImgOffsetTop = targetImg.getBoundingClientRect().top
      const headerOffset = 132 // offset from the top & below header
      const windowScrollY = window.scrollY
      // Move window from curent scrollY to new scrollY
      const scrolledYPosition = windowScrollY + targetImgOffsetTop - headerOffset
      // Show pexels logo (go to top) if it's the first image
      const scrollToYPosition = isTopImage ? 0 : scrolledYPosition

      // Scroll to the top of the target img element
      window.scrollTo(0, scrollToYPosition)
    } else {
      // Likely this is first visit to a category -> scroll to top
      window.scrollTo(0, 0)
    }
  }, [scrollToImgId, activeCategory, firstResultImgId])

  return (
    <>
      <div className="sticky-top-content">
        <div className="Home__header">
          <div className="Home__header_form_wrapper">
            <SearchForm handleSubmit={onSearch} />
          </div>
          <VirtualBackgroundMenu />
        </div>
        <Categories
          categories={categories}
          active={activeCategory}
          setActive={setActiveCategory}
        />
      </div>
      <SearchResults
        searchTerm={''}
        activeCategory={activeCategory}
        images={topicImages}
        totalImages={totalTopicPageImages}
      />
    </>
  )
}

export default Home
